import type React from 'react';
import AemImage from '@/components/AemImage/AemImage';
import AemVideo from '@/components/AemVideo/AemVideo';
import type {ImageModel, VideoModel} from '@/types/content';
import arrayUtils from '@/utils/arrayUtils';

type Props = {
    className?: string;
    containerClassName?: string;
    imgContainerClassName?: string;
    pictureClassName?: string;
    imgClassName?: string;
    videoClassName?: string;
    images?: ImageModel[];
    videos?: VideoModel;
    bgColorHex?: string;
    bgColor?: string;
    videoLoop?: boolean;
};

const Media = ({
    className,
    containerClassName,
    imgContainerClassName,
    pictureClassName,
    imgClassName,
    videoClassName,
    images,
    videos,
    bgColorHex,
    bgColor,
    videoLoop = true,
}: Props) => {
    const videoList = arrayUtils.toArray(videos);
    const hasVideos = videoList.length > 0;
    const hasImages = !hasVideos && !!images?.length;

    const backgroundStyle: React.CSSProperties | undefined = bgColor
        ? {backgroundColor: bgColor}
        : bgColorHex
          ? {backgroundColor: `#${bgColorHex}`}
          : undefined;

    const firstVideo = hasVideos ? videoList[0] : null;

    return (
        <div className={className} style={backgroundStyle}>
            {hasImages && (
                <AemImage
                    imageMedia={images}
                    className={imgContainerClassName}
                    pictureClassName={pictureClassName}
                    imgClassName={imgClassName}
                />
            )}

            {hasVideos && firstVideo && (
                <AemVideo
                    video={firstVideo}
                    className={videoClassName}
                    containerClassName={containerClassName}
                    loop={videoLoop}
                />
            )}
        </div>
    );
};

export default Media;
